import type { CSSProperties } from 'react'
import useRightPanelRedesign from '@/containers/SubscriptionFormPageNew/Components/shared/RightPanel/useRightPanelRedesign'

const rightColumnContainerStyle: CSSProperties = {
  width: '25%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
}

const rightColumnElementStatelessStyle: CSSProperties = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginBottom: '1rem',
  backgroundColor: 'white',
  borderRadius: '0.5rem',
}

const rightColumnElementStyle: CSSProperties = {
  ...rightColumnElementStatelessStyle,
  paddingTop: '1rem',
  paddingBottom: '1rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
}

const useLegacyRightPanel = (country: string) => ({
  hidden: useRightPanelRedesign(),
  ibanVerifierHidden: country !== 'be',
  rightColumnContainerStyle,
  rightColumnElementStyle,
  rightColumnElementStatelessStyle,
})

export default useLegacyRightPanel
